import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import {
    Divider,
    IconButton,
    ListItemText,
    Menu,
    MenuItem
} from '@mui/material';
import { KeyboardArrowDownSharp, Person } from '@mui/icons-material';
import './LoggedInUserAvatar.scss';
import useAuthentication from '../../account/components/hooks/useAuthentication';
import CONFIG from '../../api/config';
import Routes from '../../routing/routes';
import { navigate } from '../../state/navigation/navigation';
import useTabNavigation from '../hooks/useTabNavigation';
import useScreenDimensions from '../hooks/useScreenDimensions';

const MENU_ID = 'account-avatar-menu';
const MOBILE_BREAKPOINT = 680;

export default function LoggedInUserAvatar() {
    const { logoutUser } = useAuthentication();
    const [anchorEl, setAnchorEl] = useState(null);
    const loggedInUser = useSelector((state) => state.user?.loggedInUser);
    const { width } = useScreenDimensions();
    const isMobile = width < MOBILE_BREAKPOINT;
    const { pathname } = useLocation();
    const tabs = useTabNavigation();
    const hideTabsPaths = [Routes.ACCEPT_ASSISTANT_COACH.path];
    const showTabsInMenu = isMobile && hideTabsPaths.indexOf(pathname) === -1;

    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleSupport = () => {
        window.open(CONFIG.URL_SUPPORT, '_blank');
        handleClose();
    };

    const handleLogout = () => {
        logoutUser();
        handleClose();
    };

    const handleTabClick = (tabPath) => {
        navigate(tabPath);
        handleClose();
    };

    const profileImage = loggedInUser?.profileImage;

    return (
        <>
            <IconButton
                className="loggedInUser-avatar-button"
                aria-haspopup="true"
                aria-controls={open ? MENU_ID : undefined}
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
                data-testid="avatar-menu-button"
            >
                <div className="loggedInUser-avatar">
                    {profileImage ? (
                        <img alt="User Profile" src={profileImage} />
                    ) : (
                        <Person fontSize="small" />
                    )}
                    <KeyboardArrowDownSharp />
                </div>
            </IconButton>
            <Menu
                id={MENU_ID}
                anchorEl={anchorEl}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                open={open}
                onClose={handleClose}
                MenuListProps={{ className: 'loggedInUser-avatar-menuList' }}
            >
                {showTabsInMenu &&
                    tabs.map((tab) => (
                        <MenuItem
                            key={tab.path}
                            className="loggedInUser-avatar-menuItem"
                            onClick={() => handleTabClick(tab.path)}
                            data-testid={`avatar-menu-tab-${tab.path.replace(/^\//, '')}`}
                        >
                            <ListItemText secondary={tab.name} />
                        </MenuItem>
                    ))}
                {showTabsInMenu && tabs.length > 0 && <Divider />}
                <MenuItem className="loggedInUser-avatar-menuItem" onClick={handleSupport}>
                    <ListItemText secondary="Support" />
                </MenuItem>
                <MenuItem className="loggedInUser-avatar-menuItem" onClick={handleLogout} data-testid="logout-menu-item">
                    <ListItemText secondary="Logout" />
                </MenuItem>
            </Menu>
        </>
    );
}
